import { CPNetworkName } from "./CPNetworks.js";
import { getSecondLevelDomain, getThirdDomainName } from "../lib/utils/DomainNameUtils.js";
import { isString } from "@ciaopeople/cp-shatsu/TypeChecking";

export type CPProducts = {

    COOKIST: "COOKIST",
    COOKIST_WOW: "COOKIST_WOW",
    OHGA: "OHGA",
    KODAMI: "KODAMI",
    FANPAGE: "FANPAGE",
    LEXPLAIN: "LEXPLAIN",
    WAMILY: "WAMILY",
    GEOPOP: "GEOPOP"

}

export const AllCPProducts: CPProducts = {
    
    COOKIST: "COOKIST",
    COOKIST_WOW: "COOKIST_WOW",
    OHGA: "OHGA",
    KODAMI: "KODAMI",
    FANPAGE: "FANPAGE",
    LEXPLAIN: "LEXPLAIN",
    WAMILY: "WAMILY",
    GEOPOP: "GEOPOP"
}

export type CPProductName = keyof CPProducts

const secLevToCPProduct: Record<string,CPProductName> = {
    "fanpage.it": AllCPProducts.FANPAGE,
    "fanpage.run": AllCPProducts.FANPAGE,
    "cookist.it": AllCPProducts.COOKIST,
    "cookist.run": AllCPProducts.COOKIST,
    "cookist.com": AllCPProducts.COOKIST_WOW,
    "cookist.bar": AllCPProducts.COOKIST_WOW,
    "geopop.it": AllCPProducts.GEOPOP,
    "geopop.run": AllCPProducts.GEOPOP,
    "ohga.it": AllCPProducts.OHGA,
    "ohga.run": AllCPProducts.OHGA,
    "wamily.it": AllCPProducts.WAMILY,
    "wamily.run": AllCPProducts.WAMILY,
    "kodami.it": AllCPProducts.KODAMI,
    "kodami.run": AllCPProducts.KODAMI,
    "lexplain.it": AllCPProducts.LEXPLAIN,
    "lexplain.run": AllCPProducts.LEXPLAIN
};

const ProductToNetworkMap: Record<CPProductName,CPNetworkName> = {
    "COOKIST": "cookist",
    "COOKIST_WOW": "cookist",
    "OHGA": "ohga",
    "KODAMI" : "kodami",
    "FANPAGE": "fanpage",
    "LEXPLAIN": "lexplain",
    "WAMILY": "wamily",
    "GEOPOP": "geopop"
};


export function isCPProductName(x: any): x is CPProductName {
    return isString(x) && x in AllCPProducts;
}


export function getCPNetworkByCPProduct(context: CPProductName): CPNetworkName | null {
    return context in ProductToNetworkMap?ProductToNetworkMap[context]:"fanpage";
}


export function getCPProductFromHostname(fullhostname: string): CPProductName {
    const seclev = getSecondLevelDomain(fullhostname);
    return seclev in secLevToCPProduct?secLevToCPProduct[seclev]:"FANPAGE";

}

const YMSpecificDomainToProductkMap: Record<string,CPProductName> = {
    "cookist": "COOKIST_WOW",
    "cookistit": "COOKIST",
    "ohga": "OHGA",
    "kodami":"KODAMI",
    "youmedia": "FANPAGE",
    "lexplain": "LEXPLAIN",
    "wamily": "WAMILY",
    "geopop": "GEOPOP"
};


export function getCPProductFromYMSpecificDomain(ymSpecificDomain: string): CPProductName {
    return ymSpecificDomain in YMSpecificDomainToProductkMap?YMSpecificDomainToProductkMap[ymSpecificDomain]:"FANPAGE";
}

export function getYMHostByCPProduct(fullHostname: string, secondLevel: string, context: CPProductName): string {

    const third = getThirdDomainName(fullHostname);
    let addPref = "";
    if(third && third.startsWith("test")) {
        addPref = "test";
    }
    const ymThird = context == "FANPAGE"?"youmedia":"video";
    
    return `${ymThird}${addPref}.${secondLevel}`;

}


export function getWPHostByCPProduct(fullHostname: string, secondLevel: string, context: CPProductName): string {

    const third = getThirdDomainName(fullHostname);
    let wpThird = "test2";
    if(third && third.includes("test")) {
        wpThird = context == "OHGA" || context == "KODAMI"?"test":"test2";
        return `www.${wpThird}.${secondLevel}`;
    }
    else {
        return `www.${secondLevel}`;
    }
    
    

}